import React from "react";
import { Image } from "lucide-react";

/**
 * Modern clean white theme Image Quota Display
 */
const ImageQuotaDisplay = ({ quota, selectedDate }) => {
  if (!quota) return null;

  const isFull = quota.remaining === 0;
  const isNearFull = quota.remaining > 0 && quota.remaining <= 3;

  return (
    <div className="bg-white border border-slate-200 rounded-xl p-4 shadow-sm flex flex-col sm:flex-row sm:items-center justify-between gap-3 font-sans">
      <div className="flex items-center gap-3">
        <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${
          isFull ? "bg-rose-50 text-rose-600 border border-rose-200" : "bg-slate-100 text-slate-800 border border-slate-200"
        }`}>
          <Image className="w-5 h-5" />
        </div>
        <div>
          <h4 className="text-sm font-bold text-slate-900 flex items-center gap-2">
            Daily Image Quota
            <span className="text-xs font-normal text-slate-500">
              ({selectedDate ? selectedDate.split("T")[0] : "Selected Date"})
            </span>
          </h4>
          <p className="text-xs text-slate-600 mt-0.5">
            {isFull
              ? "All 10 image slots used for this date."
              : `You can attach ${quota.remaining} more photo${quota.remaining === 1 ? "" : "s"} today.`}
          </p>
        </div>
      </div>

      <div className="flex items-center gap-3 self-end sm:self-auto">
        <div className="text-right">
          <span className="text-xs text-slate-400 font-semibold block uppercase tracking-wider">Used</span>
          <span className="text-base font-bold text-slate-900">{quota.used} / {quota.limit}</span>
        </div>
        <div className="w-16 bg-slate-100 h-2.5 rounded-full overflow-hidden border border-slate-200">
          <div
            className={`h-full transition-all duration-300 ${
              isFull ? "bg-rose-500" : isNearFull ? "bg-amber-500" : "bg-slate-900"
            }`}
            style={{ width: `${Math.min(100, (quota.used / quota.limit) * 100)}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default ImageQuotaDisplay;
